function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m12.6 3.287a2.787 2.787 0 0 0 -2.787-2.787h-7.026a2.787 2.787 0 0 0 -2.787 2.787v8.333a1.9 1.9 0 0 0 1.909 1.88h10.818a1.263 1.263 0 0 0 1.273-1.254v-7.565a1.5 1.5 0 0 0 -1.4-1.394zm-11.2 0v-.227a1.166 1.166 0 0 1 1.167-1.166h7.466a1.166 1.166 0 0 1 1.167 1.166v.227zm8.675 6.4a1.382 1.382 0 1 1 1.388-1.387 1.386 1.386 0 0 1 -1.388 1.385z",
  fill: "currentColor"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/wallet-filled.e1a90aee.svg";
export { SvgComponent as ReactComponent };